const PRIVE_SERVICE_URL = 'https://subs.api.tryprive.com';
const PRIVE_GIFT_INPUT_NAMES = ['_gift-deliveries', '_gift-name', 'gift-email', '_gift-message'];
const PRIVE_SELLING_PLANS = new Set([
  5497225496, 5498536216, 563868495, 5638717720, 5733941528, 6018433304,
  6018400536, 6008439064, 6212354328, 6212387096, 6831505688
]);


document.addEventListener('DOMContentLoaded', function () {
    const App = {
        init() {
            this.cacheDOM();
            this.parseVariants();
            this.setupEventListeners();
            this.initializeWidget();
            this.productResponse = {};

            this.getProduct()
                .then(() => {
                    this.initializeGiftSection();
                })
                .catch(error => {
                    console.error('[Prive]', error);
                });

          console.log(`[Prive Widget]`)
        },
        cacheDOM() {
            // these come from the theme
            this.variantPickerLabels = document.querySelectorAll('.product-variants-wrap .variant-input label');
            this.textarea = document.querySelector('textarea[data-variant-json]');

            // Prive
            this.form = document.querySelector('form[action="/cart/add"]');
            this.widget = this.form.querySelector('.prive-custom-widget');
            this.radioLabels = this.widget.querySelectorAll('.prive-radio');
            this.subscriptionLabel = this.widget.querySelector('.prive-radio.subscription-radio');
            this.onetimeLabel = this.widget.querySelector('.prive-radio.onetime-radio');

            // Add gift section elements
            this.giftContainer = this.form.querySelector('#gift-container');
        },

        parseVariants() {
            this.variants = JSON.parse(this.textarea.textContent.trim());
        },
        setupEventListeners() {
            this.radioLabels.forEach(label => {
                const input = label.querySelector('input[type="radio"]');
                input.addEventListener('change', () => this.handleRadioChange(label));
            });

            if (this.variantPickerLabels.length) {
                this.variantPickerLabels.forEach(label =>
                    label.addEventListener('click', (event) => this.handleVariantChange(event))
                );
            } else {
                this.addProductPrice();
            }
        },

        initializeWidget() {
            this.removeRechargeWidget();
            this.addContentToRadios();
            this.setInitialSubscription();
            this.injectStyles();
        },
        injectStyles() {
            const styles = `
              .gift_container {
                margin-bottom: 15px;
                display: flex;
                flex-direction: column;
                flex-align: flex-start;
                gap: 10px;
                order: 6;
              }
          
              #gift-checkbox {
                margin-right: 4px;
              }
          
              .gift_checkbox_container > label {
                margin-bottom: 0 !important;
              }
          
              .gift_checkbox_container {
                display: flex;
              }
          
              .gift_form_container {
                display: flex;
                flex-direction: column;
                gap: 10px;
              }
          
              .gift_section {
                display: flex;
                flex-direction: column;
                gap: 5px;
              }
          
              .prive_label_gift {
                display: block;
                color: #525659;
                font-weight: normal;
                font-size: 14px;
              }
              
            `;

            const styleSheet = document.createElement("style");
            styleSheet.textContent = styles;
            document.head.appendChild(styleSheet);
        },
        handleRadioChange(radioLabel) {
            this.updateActiveRadio(radioLabel);
            const input = radioLabel.querySelector('input[type="radio"]');
            this.assignSellingPlan(input.getAttribute('selling-plan-id'));
            if (input.getAttribute('value') == 'subscription') {
                // document.querySelector('.product__main-photos-wrapper .product-main-slide[data-index="0"] .product-image-main  img').setAttribute('src', 'https://cdn.shopify.com/s/files/1/0745/3366/7096/files/bundle-FREEtote-tag.jpg?v=1726513477');
                // document.querySelector('.product__main-photos-wrapper .product-main-slide[data-index="0"] .product-image-main  img').setAttribute('srcset', 'https://cdn.shopify.com/s/files/1/0745/3366/7096/files/bundle-FREEtote-tag.jpg?v=1726513477');
                // document.querySelector('.product__thumbs .product__thumb-item[data-index="0"] .product__thumb img').setAttribute('src', 'https://cdn.shopify.com/s/files/1/0745/3366/7096/files/bundle-FREEtote-tag.jpg?v=1726513477');
                // document.querySelector('.product__thumbs .product__thumb-item[data-index="0"] .product__thumb img').setAttribute('srcset', 'https://cdn.shopify.com/s/files/1/0745/3366/7096/files/bundle-FREEtote-tag.jpg?v=1726513477');
                document.querySelectorAll('.product__thumbs .product__thumb-item a').forEach(itema => {
                    itema.classList.remove('is-active');
                });
                document.querySelector('.product__thumbs .product__thumb-item[data-index="0"] a').classList.add('is-active');
            } else {
                // document.querySelector('.product__main-photos-wrapper .product-main-slide[data-index="0"] .product-image-main  img').setAttribute('src', 'https://cdn.shopify.com/s/files/1/0745/3366/7096/files/bundle-onetime.jpg?v=1725637611');
                // document.querySelector('.product__main-photos-wrapper .product-main-slide[data-index="0"] .product-image-main  img').setAttribute('srcset', 'https://cdn.shopify.com/s/files/1/0745/3366/7096/files/bundle-onetime.jpg?v=1725637611');
                // document.querySelector('.product__thumbs .product__thumb-item[data-index="0"] .product__thumb img').setAttribute('src', 'https://cdn.shopify.com/s/files/1/0745/3366/7096/files/bundle-onetime.jpg?v=1725637611');
                // document.querySelector('.product__thumbs .product__thumb-item[data-index="0"] .product__thumb img').setAttribute('srcset', 'https://cdn.shopify.com/s/files/1/0745/3366/7096/files/bundle-onetime.jpg?v=1725637611');
                document.querySelectorAll('.product__thumbs .product__thumb-item a').forEach(itema => {
                    itema.classList.remove('is-active');
                });
                document.querySelector('.product__thumbs .product__thumb-item[data-index="0"] a').classList.add('is-active');
            }

            // Add these lines to clear gift options when switching to one-time purchase
            const giftCheckbox = document.querySelector('#gift-checkbox');
            if (giftCheckbox && giftCheckbox.checked) {
                giftCheckbox.checked = false;
                this.clearGiftInputs();
                this.removeGiftHiddenInputs();
                document.querySelector('#gift-form').style.display = 'none';
            }
        },

        updateActiveRadio(activeRadioLabel) {
            this.radioLabels.forEach(label =>
                label.classList.toggle('prive-radio--active', label === activeRadioLabel)
            );
        },

        assignSellingPlan(sellingPlanId) {
            let sellingPlanInput = this.form.querySelector('input[name="selling_plan"]');
            if (!sellingPlanInput) {
                sellingPlanInput = document.createElement('input');
                sellingPlanInput.name = 'selling_plan';
                sellingPlanInput.type = 'hidden';
                this.form.appendChild(sellingPlanInput);
            }
            sellingPlanInput.value = sellingPlanId;
            this.updateUrlParams('selling_plan', sellingPlanId);
        },

        addContentToRadios() {
            this.addContentToRadio(this.subscriptionLabel, '.product-subscribe-content');
            this.addContentToRadio(this.onetimeLabel, '.product-onetime-content');
        },

        addContentToRadio(radioLabel, contentClass) {
            const labelEl = radioLabel.querySelector('.prive-radio__label');
            const content = document.querySelector(contentClass)?.innerHTML;
            if (labelEl && content) {
                labelEl.insertAdjacentHTML('beforeend', content);
            }
        },

        setInitialSubscription() {
            const subscriptionInput = this.subscriptionLabel.querySelector('input[type="radio"]');
            subscriptionInput.checked = true;
            this.updateActiveRadio(this.subscriptionLabel);

            // Recharge has a 500ms setTimeout
            setTimeout(() => this.assignSellingPlan(subscriptionInput.getAttribute('selling-plan-id')), 600);
        },

        addProductPrice() {
            const variant = this.variants[0];
            const regularPrice = variant.price;
            let subscriptionPrice = this.findSubscriptionPrice(variant);
            this.updatePrice(this.subscriptionLabel, regularPrice / 100, subscriptionPrice / 100);
            this.updatePrice(this.onetimeLabel, regularPrice / 100);
            this.showPriveWidget();
        },

        handleVariantChange(event) {
            // Fix: If the user clicks on the span, we need to get the closest label
            const targetElement = event.target.tagName === 'LABEL' ?
                event.target :
                event.target.closest('label');

            const index = targetElement.closest('.variant-input').getAttribute('data-index');
            const value = targetElement.closest('.variant-input').getAttribute('data-value');
            const dataPrice = targetElement.getAttribute('data-price');

            const variant = this.variants.find((v) => v[index] === value);
            const subscriptionPrice = this.findSubscriptionPrice(variant);

            this.updatePrice(this.subscriptionLabel, dataPrice, subscriptionPrice / 100);
            this.updatePrice(this.onetimeLabel, dataPrice);

            this.updateUrlParams('variant', variant.id.toString());
            this.showPriveWidget();
            this.handleRadioChange(this.widget.querySelector('.prive-radio.prive-radio--active'));
        },

        findSubscriptionPrice(variant) {
            // hardcode the selling plans, since we can't fetch
            return variant.selling_plan_allocations.find(
                allocation => PRIVE_SELLING_PLANS.has(allocation.selling_plan_id)
            )?.price || 0;
        },

        removeRechargeWidget() {
            window.Recharge = undefined;
            document.querySelector('.recharge-subscription-widget')?.remove();
        },

        showPriveWidget() {
            this.widget.style.display = 'block';
        },

        updatePrice(radioLabel, fullPrice, discountPrice) {
            const priceDiv = radioLabel.querySelector('.label-price');
            if (priceDiv) {
                if (discountPrice !== undefined && discountPrice < fullPrice) {
                    const priceSpan = document.createElement('span');
                    priceSpan.textContent = fullPrice;
                    priceDiv.textContent = `$${discountPrice}`;
                    priceDiv.appendChild(priceSpan);
                } else {
                    priceDiv.textContent = `$${fullPrice}`;
                }
            }
        },

        updateUrlParams(key, value) {
            const url = new URL(window.location.href);
            if (!value) {
                url.searchParams.delete(key);
            } else {
                url.searchParams.set(key, value);
            }
            window.history.pushState({ path: url.href }, '', url.href);
        },
        hasGiftOptions(productId, sellingPlanId) {
            return this.productResponse[productId]?.selling_plan_groups?.some(group => group.selling_plans.some(plan => plan.sellingPlanId === sellingPlanId && plan.giftOptions));
        },
        getSellingPlan(productId) {
            const subscriptionInput = this.subscriptionLabel.querySelector('input[type="radio"]');
            const sellingPlanId = subscriptionInput.getAttribute('selling-plan-id');
            const sellingPlanGroup = this.productResponse[productId]?.selling_plan_groups?.find(group => group.selling_plans.some(plan => plan.sellingPlanId === sellingPlanId));
            const sellingPlan = sellingPlanGroup?.selling_plans.find(plan => plan.sellingPlanId === sellingPlanId);

            return sellingPlan;
        },

        initializeGiftSection() {
            const subscriptionInput = this.subscriptionLabel.querySelector('input[type="radio"]');
            const sellingPlanId = subscriptionInput.getAttribute('selling-plan-id');
            const productId = this.getProductId();

            const giftOptions = this.getSellingPlan(productId)?.giftOptions;
            const giftSection = this._getGiftSection(giftOptions);

            if (!this.widget || this.widget.classList.contains('gift-subscription-pdp')) return;

            if (giftSection && this.form && productId) {
                // Initially hide the gift section
                giftSection.style.display = 'none';

              
                const nextSibling = this.widget.nextElementSibling;
                this.form.insertBefore(giftSection, nextSibling);
              

                // Create MutationObserver to watch widget display changes
                const observer = new MutationObserver(() => {
                    const isWidgetVisible = this.widget.style.display === 'block';
                    const hasGiftOptions = isWidgetVisible && this.hasGiftOptions(productId, sellingPlanId);

                    // Update gift section visibility and state
                    giftSection.style.display = hasGiftOptions ? 'block' : 'none';

                    if (!hasGiftOptions) {
                        this.clearGiftInputs();
                        this.removeGiftHiddenInputs();
                        this.disableSubmitButtons(false);
                    }
                });

                // Start observing the widget
                observer.observe(this.widget, { attributes: true });

                this.radioLabels.forEach(label => {
                    // For each radio label element...
                    const input = label.querySelector('input[type="radio"]');

                    // Add a change event listener to its radio input
                    input.addEventListener('change', () => {
                        const productId = this.getProductId();
                        const sellingPlanId = input.getAttribute('selling-plan-id');

                        // If the widget is visible...
                        if (this.widget.style.display === 'block') {
                            // Show/hide gift section based on conditions
                            giftSection.style.display = (
                                input.value === 'subscription' &&
                                this.hasGiftOptions(productId, sellingPlanId)
                            ) ? 'block' : 'none';
                        }
                    });
                });


                // Initial Display
                giftSection.style.display = (
                    subscriptionInput.checked &&
                    this.widget.style.display === 'block' &&
                    this.hasGiftOptions(productId, sellingPlanId)
                ) ? 'block' : 'none';
            }
        },

        _getGiftSection(giftOptions) {
            if (!giftOptions) return;
            const maxDeliveries = giftOptions.maxDeliveries || 12;

            // Create gift checkbox
            const giftCheckboxInput = Object.assign(document.createElement('input'), {
                type: 'checkbox',
                name: 'isGift',
                id: 'gift-checkbox',
            });

            const giftCheckboxLabel = Object.assign(document.createElement('label'), {
                htmlFor: 'gift-checkbox',
            });
            giftCheckboxLabel.appendChild(document.createTextNode('Is this a gift?'));

            const giftCheckboxContainer = Object.assign(document.createElement('div'), {
                classList: 'gift_checkbox_container',
            });
            giftCheckboxContainer.appendChild(giftCheckboxInput);
            giftCheckboxContainer.appendChild(giftCheckboxLabel);

            // Gift Delivery Number
            const giftNumberLabel = Object.assign(document.createElement('label'), {
                htmlFor: '_gift-number-dropdown',
                classList: 'prive_label_gift',
            });
            giftNumberLabel.appendChild(document.createTextNode('Number of deliveries'));

            const giftNumberDropdown = Object.assign(document.createElement('select'), {
                name: '_gift-deliveries',
                id: 'gift-number-dropdown',
                placeholder: '0',
                classList: 'prive_select',
            });
            const giftNumberOptions = Array.apply(0, { length: maxDeliveries }).map(function () {
                return arguments[1] + 1;
            });
            giftNumberOptions.forEach(function (option) {
                const optionElement = Object.assign(document.createElement('option'), {
                    value: option,
                    label: option + 1,
                });
                optionElement.appendChild(document.createTextNode(option));
                giftNumberDropdown.appendChild(optionElement);
            });
            giftNumberDropdown.value = giftNumberOptions[0];
            const giftNumberSection = Object.assign(document.createElement('div'), {
                classList: 'gift_section',
            });
            giftNumberSection.appendChild(giftNumberLabel);
            giftNumberSection.appendChild(giftNumberDropdown);

            // Gift Recipient Name
            const giftNameLabel = Object.assign(document.createElement('label'), {
                htmlFor: '_gift-name',
                classList: 'prive_label_gift',
            });
            giftNameLabel.appendChild(document.createTextNode('To'));
            const giftNameInput = Object.assign(document.createElement('input'), {
                type: 'text',
                placeholder: 'Name (optional)',
                name: '_gift-name',
                classList: 'prive_input',
            });

            // Gift Recipient Email
            const giftEmailInput = Object.assign(document.createElement('input'), {
                type: 'email',
                placeholder: 'Email',
                name: 'gift-email',
                classList: 'prive_input',
            });

            const giftToSection = Object.assign(document.createElement('div'), {
                classList: 'gift_section',
            });
            giftToSection.appendChild(giftNameLabel);
            giftToSection.appendChild(giftNameInput);
            giftToSection.appendChild(giftEmailInput);

            // Gift Recipient Message
            const giftMessageLabel = Object.assign(document.createElement('label'), {
                htmlFor: '_gift-message',
                classList: 'prive_label_gift',
            });
            giftMessageLabel.appendChild(document.createTextNode('Message (maximum 200 characters)'));
            const giftMessageInput = Object.assign(document.createElement('textarea'), {
                placeholder: 'Add a message (optional)',
                name: '_gift-message',
                classList: 'prive_textarea',
            });
            giftMessageInput.setAttribute('maxlength', '200');
            const giftMessageSection = Object.assign(document.createElement('div'), {
                classList: 'gift_section',
            });
            giftMessageSection.appendChild(giftMessageLabel);
            giftMessageSection.appendChild(giftMessageInput);

            // Gift Form
            const giftForm = Object.assign(document.createElement('div'), {
                classList: 'gift_form_container',
                id: 'gift-form',
            });
            giftForm.style.display = 'none';
            giftForm.appendChild(giftNumberSection);
            giftForm.appendChild(giftToSection);
            giftForm.appendChild(giftMessageSection);

            // Gift Section
            const giftContainer = Object.assign(document.createElement('div'), {
                classList: 'gift_container',
                id: 'gift-container',
            });
            giftContainer.appendChild(giftCheckboxContainer);
            giftContainer.appendChild(giftForm);

            const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
            giftEmailInput.addEventListener('input', function (e) {
                document
                    .querySelectorAll('form[action^="/cart/add"] button[type=\'submit\']')
                    ?.forEach(function (button) {
                        button.disabled = !emailRegex.test(e.target.value);
                    });
            });

            // Event listeners
            giftCheckboxInput.addEventListener('change', () => {
                const giftForm = document.querySelector('#gift-form');
                if (giftCheckboxInput.checked) {
                    giftForm.style.display = '';

                    this.addGiftHiddenInputs(giftNumberOptions[0]);
                    this.mirrorGiftHiddenInputs(PRIVE_GIFT_INPUT_NAMES);
                    this.disableSubmitButtons(true);
                } else {
                    giftForm.style.display = 'none';
                    this.clearGiftInputs();
                    this.removeGiftHiddenInputs();
                    this.disableSubmitButtons(false);
                }
            });

            return giftContainer;
        },
        /**
         * Removes hidden gift inputs from the cart form
         */
        removeGiftHiddenInputs: function () {
            document.querySelectorAll(`form[action^="/cart/add"]`).forEach(function (form) {
                if (form.querySelector(`button[type='submit']`)) {
                    PRIVE_GIFT_INPUT_NAMES.forEach(function (input) {
                        const hiddenInputToRemove = form.querySelector(`input[name='properties[${input}]']`);
                        if (hiddenInputToRemove) {
                            form.removeChild(hiddenInputToRemove);
                        }
                    });
                }
            });
        },
        /**
         * Mirrors gift inputs to hidden inputs
         * @param inputs Array of inputs to mirror
         */
        mirrorGiftHiddenInputs: function (inputNames) {
            inputNames.forEach(function (inputName) {
                const input = document.querySelector(`[name="${inputName}"]`);
                if (input) {
                    input.addEventListener('change', function () {
                        const hiddenInput = document.querySelector(`input[name="properties[${this.name}]"]`);
                        if (hiddenInput) {
                            hiddenInput.value = this.value;
                        }
                    });
                }
            });
        },
        disableSubmitButtons(disabled) {
            document.querySelectorAll('form[action^="/cart/add"] button[type="submit"]')
                .forEach(button => button.disabled = disabled);
        },
        clearGiftInputs() {
            PRIVE_GIFT_INPUT_NAMES.forEach(inputName => {
                const input = document.querySelector(`[name="${inputName}"]`);
                if (input) input.value = '';
            });
            const dropdown = document.querySelector('#gift-number-dropdown');
            if (dropdown) dropdown.selectedIndex = 0;
        },
        addGiftHiddenInputs: function (giftOptions) {
            const form = document.querySelector('form[action^="/cart/add"]');
            if (!form) return;

            PRIVE_GIFT_INPUT_NAMES.forEach(inputName => {
                const hiddenInput = document.createElement('input');
                hiddenInput.type = 'hidden';
                hiddenInput.name = `properties[${inputName}]`;

                if (inputName === '_gift-deliveries') {
                    hiddenInput.value = giftOptions
                }

                form.appendChild(hiddenInput);
            });
        },
        getProductId: function () {
            let id = this.form.getAttribute('data-product-id') || window.meta?.product?.id;
            if (!id) {
                console.log('[Prive]No product ID found.');
                return null;
            }
            return id;
        },
        getProduct: async function () {
            try {
                const id = this.getProductId();
                if (!id) throw new Error('Product ID not found');

                const ENDPOINT = `${PRIVE_SERVICE_URL}/stores/${window.Shopify.shop}/products/${id}/new`;
                const response = await fetch(ENDPOINT);

                if (!response.ok) {
                    throw new Error(`API request failed with status ${response.status}`);
                }

                const details = await response.json();
                if (!details) throw new Error('No data received from API');

                this.productResponse = {
                    [id]: details
                };
            } catch (error) {
                console.error('[API] Get product error:', error);
                // Optionally handle the error UI here
            }
        },
    }
    App.init();
});